var map = {
	"./Sk_resident2ru.webp": "94c3",
	"./en/ai/1.webp": "b43a",
	"./en/ai/2.webp": "8186",
	"./en/ai/3.webp": "e3e9",
	"./en/ai/4.webp": "b9c8",
	"./en/blog/1.webp": "7132",
	"./en/blog/2.webp": "6ef1",
	"./en/blog/3.webp": "4c12",
	"./en/blog/4.webp": "dda7",
	"./en/business/1_A.webp": "d1b6",
	"./en/business/1_B.webp": "5b0e",
	"./en/business/1_C.webp": "9cd2",
	"./en/business/1_D.webp": "a470",
	"./en/business/2_A.webp": "d0a3",
	"./en/business/2_B.webp": "8dca",
	"./en/business/2_C.webp": "1206",
	"./en/business/2_D.webp": "3bf8",
	"./en/business/2_E.webp": "f127",
	"./en/business/3.webp": "eb9b",
	"./en/business/4.webp": "ecb8",
	"./phones/1.webp": "6710",
	"./ru/ai/1.webp": "6b1e",
	"./ru/ai/2.webp": "b56c",
	"./ru/ai/3.webp": "f544",
	"./ru/ai/4.webp": "b5c9",
	"./ru/blog/1.webp": "7668",
	"./ru/blog/2.webp": "b6c8",
	"./ru/blog/3.webp": "379e",
	"./ru/blog/4.webp": "447f",
	"./ru/business/1_A.webp": "0fb4",
	"./ru/business/1_B.webp": "0fc7",
	"./ru/business/1_C.webp": "f182",
	"./ru/business/1_D.webp": "7038",
	"./ru/business/2_A.webp": "c420",
	"./ru/business/2_B.webp": "fce2",
	"./ru/business/2_C.webp": "05dc",
	"./ru/business/2_D.webp": "2927",
	"./ru/business/2_E.webp": "db6b",
	"./ru/business/3.webp": "b45b",
	"./ru/business/4.webp": "da77"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c955";